
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class PreferencesPanel extends Vue {
  @Prop()
  save!: {
    text: string;
    function: () => void;
    inProgress: boolean;
    disabled: boolean;
  };
  @Prop({ default: false })
  hideSaveButton!: boolean;
}
